var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.agentConditions.sale)?_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('v-icon',{staticStyle:{"margin":"0"},attrs:{"right":"","small":""},on:{"click":() => _vm.getFilterNotes(_vm.item, _vm.item.agentConditions.sale)}},[_vm._v("info")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }